export enum VitalSignRespiratoryMonitoringTabs {
  VITAL_SIGN = 'vitalsign',
  RESPIRATORY_MONITORING = 'respiratorymonitoring'
}